<template>
  <div class="trainingCourseAdmin">
    <el-button size="small" type="primary" @click="addCurriculum" icon="el-icon-plus">添加物料</el-button>
    <el-form class="form-style" :inline="true" size="small" @submit.native.prevent>
      <el-form-item label="活动名称:">
        <el-input v-model="title" clearable placeholder="请输入活动名称" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary">搜索</el-button>
      </el-form-item>
    </el-form>

    <div class="table-style">
      <el-table size="small" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column align="center" width="120" type="index" label="序号"></el-table-column>

        <el-table-column align="center" width="100" label="封面">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 18px" :src="scope.row.img_url" fit="fill"></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="sort_num" label="排序号"></el-table-column>
        <el-table-column align="center" prop="subjectName" label="科目"></el-table-column>
        <el-table-column align="center" prop="sceneName" label="场景"></el-table-column>
        <el-table-column align="center" prop="" label="物料类型">
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.typeNameArr" :key="index">
              <span style="margin-right: 10px;">{{
                item.typeName
              }}</span></span>
          </template>

        </el-table-column>

        <el-table-column align="center" prop="title" label="标题"></el-table-column>

        <el-table-column align="center" prop="tch_num" label="观看人数"></el-table-column>
        <el-table-column align="center" prop="new_state" label="等级"></el-table-column>
        <el-table-column align="center" label="操作" width="350px">
          <template slot-scope="scope">
            <el-button size="small" @click="editbtn(scope.row)" type="text">修改</el-button>
            <el-button size="small" @click="goFile(scope.row)" type="text">文件列表</el-button>
            <el-button size="small" type="text" @click="zhiding(scope.row)">置顶等级</el-button>

            <el-button type="text" size="small" @click="isState(scope.row)"
              v-if="scope.row.is_post === false">发布</el-button>
            <el-button type="text" size="small" @click="isState1(scope.row)"
              v-if="scope.row.is_post === true">取消发布</el-button>

            <el-button size="small" type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page="page_no" layout="total, prev, pager, next"
        :total="total" :page-size="page_size"></el-pagination>
    </div>

    <!-- 是否置顶弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="30%">
      <el-form ref="form" :model="formGad" label-width="80px">
        <el-form-item label="置顶等级">
          <el-select v-model="formGad.new_state" placeholder="请选择">
            <el-option v-for="item in newState" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="isTopping">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  baseMeterial,
  delBaseMeterial,
  isMeterialState,
  isTop
} from "@/api/operationalActivities.js";
export default {
  data() {
    return {
      newState: [
        {
          value: "0",
          label: "不置顶"
        },
        {
          value: "1",
          label: "1级"
        },
        {
          value: "2",
          label: "2级"
        },
        {
          value: "3",
          label: "3级"
        },
        {
          value: "4",
          label: "4级"
        },

        {
          value: "5",
          label: "5级"
        },
        {
          value: "6",
          label: "6级"
        }
      ],
      dialogVisible1: false,
      tch_training_id: "",
      user: {},
      tableDataDialog: [],
      dialogVisible: false,
      total1: 0,
      page1_no: 1,
      page1_size: 20,
      total: 0,
      page_no: 1,
      page_size: 20,
      title: "",
      subject_id: "",
      post_state: "",
      subjectList: [],
      tableData: [],
      formGad: {
        new_state: "",
        base_meterial_id: ""
      }
    };
  },
  created() {
    // this.getAdminSubjectList();
  },
  mounted() {
    this.baseMeterial();
  },
  methods: {
    //是否置顶弹窗
    zhiding(row) {
      this.dialogVisible1 = true;
      console.log(row.id, "测试");
      this.formGad.base_meterial_id = row.id;
    },
    //是否置顶
    isTopping() {
      isTop(
        {
          base_meterial_id: this.formGad.base_meterial_id,
          new_state: this.formGad.new_state
        },
        true
      ).then(() => {
        this.dialogVisible1 = false;
        this.$message.success("置顶成功");
        // this.activityList();
        this.baseMeterial();

      });
    },
    //是否发布
    isState(row) {
      this.$confirm("是否发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          isMeterialState({
            base_meterial_id: row.id,
            is_post: 1
          }).then(() => {
            this.$message({
              type: "success",
              message: "发布成功!"
            });
            this.baseMeterial();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消发布"
          });
        });
    },
    isState1(row) {
      this.$confirm("是否取消发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          isMeterialState({
            base_meterial_id: row.id,
            is_post: 0
          }).then(() => {
            this.$message({
              type: "success",
              message: "取消发布成功!"
            });
            this.baseMeterial();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作"
          });
        });
    },
    //获取列表
    baseMeterial() {
      baseMeterial({
        title: this.title,
        page_no: this.page_no,
        page_size: this.page_size
      }).then(res => {
        console.log(res);
        this.tableData = res.baseMeterialList;
        this.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.baseMeterial();
    },
    //获取科目
    // getAdminSubjectList() {
    //   getAdminSubjectList().then(res => {
    //     console.log(res);
    //     this.subjectList = res.subject_list;
    //   });
    // },
    // 添加
    addCurriculum() {
      this.$router.push({
        name: "addBasicMaterial",
        query: {
          act: "add"
        }
      });
    },
    //编辑
    editbtn(row) {
      this.$router.push({
        name: "addBasicMaterial",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    //删除
    del(row) {
      this.$confirm("确定删除当前物料?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delBaseMeterial(
          {
            base_meterial_id: row.id
          },
          true
        ).then(() => {
          this.$message.success("删除成功！");
          this.baseMeterial();
        });
      });
    },
    goFile(row) {
      this.$router.push({
        name: "materialFile",
        query: {
          id: row.id
        }
      });
    },
    //检索
    search() {
      this.page_no = 1
      this.baseMeterial();
    }
  }
};
</script>

<style lang="scss" scoped>
.trainingCourseAdmin {
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin: 10px;
  padding: 15px;

  .form-style {
    margin-left: 15px;
  }

  .table-style {
    margin-top: 15px;
    cursor: pointer;
  }
}
</style>